import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../i18n";
import { termsCopy } from "../termsCopy";
import Header from "./Header";
import Footer from "./Footer";
import { Divider } from "./Reveal";

const TermsPage = () => {
    const { lang } = useLang();
    const c = termsCopy[lang] || termsCopy.en;

    useEffect(() => {
        document.title = `${c.title} | LARIVA Italian Lakes Collection`;
        window.scrollTo(0, 0);
    }, [c.title]);

    return (
        <>
            <Header />
            <main data-testid="terms-page" className="bg-ivory px-6 pt-32 pb-24 md:pt-40">
                <div className="mx-auto max-w-3xl">
                    <p className="text-center text-[10px] tracking-[0.42em] text-champagne uppercase">
                        {c.eyebrow}
                    </p>
                    <h1 className="mt-5 text-center font-serif text-4xl text-ink md:text-5xl">{c.title}</h1>
                    <div className="mt-6">
                        <Divider />
                    </div>
                    <p className="mt-6 text-center text-xs tracking-[0.2em] text-ink/50 uppercase">{c.updated}</p>
                    <p className="mx-auto mt-8 max-w-xl text-center text-sm leading-relaxed text-ink/70">
                        {c.intro}
                    </p>

                    <div className="mt-16 space-y-14">
                        {c.sections.map((s) => (
                            <section key={s.n} data-testid={`terms-section-${s.n}`}>
                                <div className="flex items-baseline gap-4">
                                    <span className="font-serif text-sm italic text-champagne">{s.n}</span>
                                    <h2 className="font-serif text-2xl text-ink md:text-[26px]">{s.h}</h2>
                                </div>
                                <div className="mt-4 space-y-4 border-l border-champagne/30 pl-6">
                                    {s.p.map((para, i) => (
                                        <p
                                            key={i}
                                            className="text-sm leading-relaxed whitespace-pre-line text-ink/70"
                                            data-testid={s.n === "09" && i === 1 ? "terms-operator" : undefined}
                                        >
                                            {para.includes("hello@larivacomo.com") ? (
                                                <>
                                                    {para.split("hello@larivacomo.com")[0]}
                                                    <a
                                                        href="mailto:hello@larivacomo.com"
                                                        className="text-champagne transition-colors duration-500 hover:text-ink"
                                                    >
                                                        hello@larivacomo.com
                                                    </a>
                                                </>
                                            ) : (
                                                para
                                            )}
                                        </p>
                                    ))}
                                </div>
                            </section>
                        ))}
                    </div>

                    <div className="mt-20 text-center">
                        <Link
                            to={lang === "it" ? "/it" : "/"}
                            data-testid="terms-back-link"
                            className="group inline-flex items-center gap-3 text-[11px] tracking-[0.3em] text-ink uppercase"
                        >
                            <ArrowLeft
                                size={14}
                                strokeWidth={1.6}
                                className="text-champagne transition-transform duration-500 group-hover:-translate-x-1.5"
                            />
                            <span className="border-b border-transparent pb-1 transition-colors duration-500 group-hover:border-champagne">
                                {c.back}
                            </span>
                        </Link>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default TermsPage;
